import { createContext } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const MAPBOX_TOKEN =
  'pk.eyJ1IjoiYnVpbGRpbmdjb25uZWN0ZWQiLCJhIjoiY2tiY3dsNGN6MDV6eTJxcGpsNzdlZGVlYiJ9.IZRpOd2-B-S9izsmviavGA';

export const CategorizedContentStoreContext = createContext();
